import { render } from "./UserProfiles.vue?vue&type=template&id=6cb4fd74"
import script from "./UserProfiles.vue?vue&type=script&lang=js"
export * from "./UserProfiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__